import React, { PureComponent } from 'react';
import monsterNames from '../data/names';
import monsterImages from '../data/photoList';

export class MonsterRenderer extends PureComponent {
  render() {
    const { data, rowData, columnData } = this.props;
    const pedigree = monsterNames[rowData];
    const father = monsterNames[columnData];
    const resultName = monsterNames[data];
    const title = `${pedigree} + ${father} = ${resultName}`;
    const imageUrl = monsterImages[data];
    if (!imageUrl) console.log('missing', data);
    return (
      <div {...this.props}>
        <img title={title} style={{ width: '100%', height: '100%' }} src={imageUrl} />
      </div>
    );
  }
}
